import { useEffect, useState } from "react";

// Natural sizes by URL, shared across panels and remounts
const sizeCache = new Map();

/** Natural { width, height } of an image URL, or null until it loads. */
export const useImageSize = (url) => {
  const [size, setSize] = useState(() => (url ? sizeCache.get(url) || null : null));

  useEffect(() => {
    if (!url) {
      setSize(null);
      return undefined;
    }
    const cached = sizeCache.get(url);
    if (cached) {
      setSize(cached);
      return undefined;
    }
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      const measured = { width: img.naturalWidth, height: img.naturalHeight };
      sizeCache.set(url, measured);
      if (!cancelled) setSize(measured);
    };
    img.src = url;
    return () => { cancelled = true; };
  }, [url]);

  return size;
};

/**
 * Where panel art is drawn: cover the panel, scale by zoom about the centre,
 * then offset by pan (% of the panel). Same maths as the PNG export.
 */
export const artPlacement = (panelW, panelH, imageSize, zoomPct = 100, panX = 0, panY = 0) => {
  const scale = Math.max(panelW / imageSize.width, panelH / imageSize.height) * (zoomPct / 100);
  const width = imageSize.width * scale;
  const height = imageSize.height * scale;
  return {
    left: (panelW - width) / 2 + (panX / 100) * panelW,
    top: (panelH - height) / 2 + (panY / 100) * panelH,
    width,
    height,
    // Furthest the art can slide (as pan %) and still cover the panel
    maxPanX: (Math.max(0, width - panelW) / 2 / panelW) * 100,
    maxPanY: (Math.max(0, height - panelH) / 2 / panelH) * 100,
  };
};
